/**
 * Search functionality fixes
 * 1. Fix slow "View All" button loading time
 * 2. Fix automatic navigation to search results page
 */
document.addEventListener('DOMContentLoaded', function() {
  // Fix 1: Optimize the "View All" button to make it faster
  function optimizeViewAllButton() {
    // Monitor for dynamically added elements
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          // Look for View All buttons in the added nodes
          const viewAllLinks = document.querySelectorAll('.search-results__meta-view-all a');
          
          viewAllLinks.forEach(function(link) {
            // Skip if we've already processed this link
            if (link.dataset.optimized) return;
            
            // Mark as processed
            link.dataset.optimized = 'true';
            
            // Get the current href
            const origHref = link.getAttribute('href');
            
            // Remove the asterisk (*) from the search query if present
            if (origHref.includes('*')) {
              const newHref = origHref.replace(/\*(?=[^*]*$)/, '');
              link.setAttribute('href', newHref);
            }
            
            // Add click event with preloading
            link.addEventListener('click', function(e) {
              e.preventDefault();
              
              // Show loading indicator to provide feedback
              document.body.classList.add('search-loading');
              
              // Add small delay to show loading indicator
              setTimeout(function() {
                window.location.href = link.getAttribute('href');
              }, 50);
            });
          });
        }
      });
    });
    
    // Observe the entire document for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Fix 2: Prevent automatic navigation to search results on API failure
  function preventAutomaticNavigation() {
    // Override the fetch method to intercept search API calls
    const originalFetch = window.fetch;
    
    window.fetch = function(input, init) {
      // Check if this is a search API call
      if (typeof input === 'string' && input.includes('/search/suggest.json')) {
        return originalFetch(input, init)
          .then(response => {
            // If response is not OK, we'll handle it ourselves
            if (!response.ok) {
              console.error('Search API error:', response.status);
              // Return a mock successful response instead of redirecting
              return new Response(JSON.stringify({
                resources: { results: {} }
              }), {
                status: 200,
                headers: { 'Content-Type': 'application/json' }
              });
            }
            return response;
          })
          .catch(error => {
            console.error('Search fetch error:', error);
            // Return a mock successful response instead of redirecting
            return new Response(JSON.stringify({
              resources: { results: {} }
            }), {
              status: 200,
              headers: { 'Content-Type': 'application/json' }
            });
          });
      }
      
      // For all other fetch calls, proceed normally
      return originalFetch(input, init);
    };
  }
  
  // Add a simple CSS class for loading state
  const style = document.createElement('style');
  style.textContent = `
    .search-loading {
      cursor: progress;
    }
    .search-loading .search-results__meta-view-all a {
      opacity: 0.7;
      pointer-events: none;
    }
  `;
  document.head.appendChild(style);
  
  // Initialize the fixes
  optimizeViewAllButton();
  preventAutomaticNavigation();
}); 